module.exports = __webpack_public_path__ + "img/2.06.thmb.1733bb96.jpg";